import APIController from '../core-api-controller';

export const fetchQuestionnairesApi = (paramsStr = '', paramsObj = {}) => {
  const path = `${APIController.endpointApi}/product_questionnaires${paramsStr ? paramsStr : ''}`;
  return APIController.getApiCallback(path, paramsObj);
};

export const updateQuestionnairesApi = (id = '', data = {}) => {
  const path = `${APIController.endpointApi}/product_questionnaires/${id}`;
  return APIController.putCallback(path, data);
};
